export enum Role { 
    Admin = "Admin",
    RaedOnly = "ReadOnly",
    Builder = "Builder"
} 